var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceivedCommisionsIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5387:32808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17555 10.5214H30.4299V6.06665H6.17555C5.11243 6.06665 4.24023 7.04316 4.24023 8.27638C4.24023 9.50961 5.11243 10.5214 6.17555 10.5214Z",
    fill: "#BF4934"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4299 6.03125H6.17555C5.11026 6.03125 4.24023 7.043 4.24023 8.27622C4.24023 8.44988 4.25759 8.6185 4.29014 8.77957C4.48757 7.78545 5.25996 7.03796 6.17555 7.03796H30.4299V6.03125Z",
    fill: "#EB7F61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88632 15.069L24.3912 0.433913C24.7188 0.174684 25.1679 0.272839 25.3914 0.652873L32.3776 12.5371C32.6011 12.9171 32.5143 13.4381 32.1889 13.6948L13.684 28.3324C13.3586 28.5917 12.9094 28.4935 12.686 28.1135L5.69756 16.2267C5.47626 15.8492 5.56087 15.3282 5.88632 15.069Z",
    fill: "#00C49A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73941 14.82L24.2443 0.182383C24.5697 -0.0743287 25.0188 0.0238257 25.2423 0.401343L32.2285 12.2881C32.452 12.6681 32.3674 13.1891 32.0398 13.4458L13.5349 28.0834C13.2095 28.3426 12.7604 28.242 12.5369 27.8645L5.55065 15.9777C5.32718 15.6002 5.4118 15.0792 5.73941 14.82Z",
    fill: "#00DCAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00195 16.7453L25.6936 1.16895L27.3946 4.06576L7.70295 19.6421L6.00195 16.7453Z",
    fill: "#0E4275"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7201 11.4323L19.0923 6.39373L18.2179 11.3241L11.8457 16.3652L12.7201 11.4323ZM20.7325 5.09507L22.6635 3.56738L21.7892 8.50027L19.8582 10.028L20.7325 5.09507Z",
    fill: "#18528C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1445 23.2712L20.0357 16.2368L20.2787 16.6496L11.3875 23.6815L11.1445 23.2712Z",
    fill: "#00AD88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8613 24.4919L17.8474 19.7578L18.0904 20.1706L12.1043 24.9046L11.8613 24.4919Z",
    fill: "#00AD88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5801 25.7149L19.9091 19.9163L20.1521 20.329L12.8231 26.1277L12.5801 25.7149Z",
    fill: "#00AD88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9902 18.8542L22.3163 16.2217L22.5593 16.6344L19.2332 19.267L18.9902 18.8542Z",
    fill: "#00AD88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0703 21.4467L27.9785 7.27972L26.9392 5.51294L9.0332 19.6774L10.0703 21.4467Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5273 13.6597L26.2797 6.73853L26.77 7.56906L18.0177 14.4927L17.5273 13.6597Z",
    fill: "#BAC1CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.149 12.0414C25.1362 11.2612 26.4792 11.5557 27.1517 12.7008C27.8243 13.8434 27.5705 15.4038 26.5833 16.184C25.5983 16.9642 24.2531 16.6698 23.5805 15.5246C22.9079 14.382 23.164 12.8216 24.149 12.0414Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3584 10.2921C27.3456 9.51194 28.6886 9.80641 29.3612 10.9515C30.0338 12.0942 29.7799 13.6546 28.7949 14.4348C27.8077 15.215 26.4626 14.9205 25.7922 13.7754C25.1196 12.6328 25.3734 11.0723 26.3584 10.2921Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5217 10.5666C27.3787 9.88963 28.546 10.1438 29.1296 11.138C29.7132 12.1296 29.4919 13.4836 28.6349 14.1606C27.7801 14.8376 26.6128 14.5809 26.0292 13.5893C25.4456 12.5952 25.6669 11.2437 26.5217 10.5666Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6253 14.538C27.0113 14.5556 26.4016 14.2208 26.0284 13.5891C25.6574 12.9549 25.6118 12.1772 25.8505 11.5178C26.4038 11.6562 26.9136 12.0338 27.2564 12.6177C27.6014 13.2015 27.7164 13.8911 27.6253 14.538Z",
    fill: "#FAB812"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3108 12.3157C25.1678 11.6387 26.3329 11.8928 26.9165 12.887C27.5001 13.8786 27.281 15.2326 26.424 15.9096C25.5691 16.5866 24.4019 16.3299 23.8182 15.3383C23.2346 14.3442 23.4559 12.9927 24.3108 12.3157Z",
    fill: "#FF8527"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4299 10.5188V31.0029H6.49232C5.25346 31.0029 4.24023 29.8276 4.24023 28.3905V8.27637C4.24023 9.50959 5.11026 10.5188 6.17555 10.5188H30.4299Z",
    fill: "#D1543E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24518 29.553C6.13453 29.553 6.04557 29.4498 6.04557 29.3215C6.04557 29.1957 6.13453 29.0925 6.24518 29.0925H7.33651C7.44716 29.0925 7.53611 29.1957 7.53611 29.3215C7.53611 29.4498 7.44716 29.553 7.33651 29.553H6.24518ZM8.52764 29.553C8.41698 29.553 8.32803 29.4498 8.32803 29.3215C8.32803 29.1957 8.41698 29.0925 8.52764 29.0925H9.32172C9.43021 29.0925 9.51916 29.1957 9.51916 29.3215C9.51916 29.4498 9.43021 29.553 9.32172 29.553H8.52764ZM10.5107 29.553C10.4022 29.553 10.3132 29.4498 10.3132 29.3215C10.3132 29.1957 10.4022 29.0925 10.5107 29.0925H11.3048C11.4154 29.0925 11.5022 29.1957 11.5022 29.3215C11.5022 29.4498 11.4154 29.553 11.3048 29.553H10.5107ZM12.4959 29.553C12.3853 29.553 12.2963 29.4498 12.2963 29.3215C12.2963 29.1957 12.3853 29.0925 12.4959 29.0925H13.2878C13.3985 29.0925 13.4874 29.1957 13.4874 29.3215C13.4874 29.4498 13.3985 29.553 13.2878 29.553H12.4959ZM14.479 29.553C14.3705 29.553 14.2815 29.4498 14.2815 29.3215C14.2815 29.1957 14.3705 29.0925 14.479 29.0925H15.273C15.3815 29.0925 15.4705 29.1957 15.4705 29.3215C15.4705 29.4498 15.3815 29.553 15.273 29.553H14.479ZM16.462 29.553C16.3535 29.553 16.2646 29.4498 16.2646 29.3215C16.2646 29.1957 16.3535 29.0925 16.462 29.0925H17.2561C17.3667 29.0925 17.4557 29.1957 17.4557 29.3215C17.4557 29.4498 17.3667 29.553 17.2561 29.553H16.462ZM18.4472 29.553C18.3366 29.553 18.2476 29.4498 18.2476 29.3215C18.2476 29.1957 18.3366 29.0925 18.4472 29.0925H19.2391C19.3498 29.0925 19.4387 29.1957 19.4387 29.3215C19.4387 29.4498 19.3498 29.553 19.2391 29.553H18.4472ZM20.4303 29.553C20.3218 29.553 20.2328 29.4498 20.2328 29.3215C20.2328 29.1957 20.3218 29.0925 20.4303 29.0925H21.2244C21.3328 29.0925 21.4218 29.1957 21.4218 29.3215C21.4218 29.4498 21.3328 29.553 21.2244 29.553H20.4303ZM22.4133 29.553C22.3048 29.553 22.2159 29.4498 22.2159 29.3215C22.2159 29.1957 22.3048 29.0925 22.4133 29.0925H23.2074C23.3181 29.0925 23.407 29.1957 23.407 29.3215C23.407 29.4498 23.3181 29.553 23.2074 29.553H22.4133ZM24.3985 29.553C24.2879 29.553 24.1989 29.4498 24.1989 29.3215C24.1989 29.1957 24.2879 29.0925 24.3985 29.0925H25.1905C25.3011 29.0925 25.3901 29.1957 25.3901 29.3215C25.3901 29.4498 25.3011 29.553 25.1905 29.553H24.3985ZM26.3816 29.553C26.2731 29.553 26.1842 29.4498 26.1842 29.3215C26.1842 29.1957 26.2731 29.0925 26.3816 29.0925H27.1757C27.2842 29.0925 27.3731 29.1957 27.3731 29.3215C27.3731 29.4498 27.2842 29.553 27.1757 29.553H26.3816ZM28.3646 29.553C28.2562 29.553 28.1672 29.4498 28.1672 29.3215C28.1672 29.1957 28.2562 29.0925 28.3646 29.0925H29.1587C29.2694 29.0925 29.3583 29.1957 29.3583 29.3215C29.3583 29.4498 29.2694 29.553 29.1587 29.553H28.3646ZM29.6968 28.3349C29.6968 28.4608 29.6078 28.5639 29.4972 28.5639C29.3887 28.5639 29.2998 28.4608 29.2998 28.3349V27.4138C29.2998 27.2879 29.3887 27.1847 29.4972 27.1847C29.6078 27.1847 29.6968 27.2879 29.6968 27.4138V28.3349ZM29.6968 26.0321C29.6968 26.1604 29.6078 26.2636 29.4972 26.2636C29.3887 26.2636 29.2998 26.1604 29.2998 26.0321V25.1134C29.2998 24.9851 29.3887 24.8819 29.4972 24.8819C29.6078 24.8819 29.6968 24.9851 29.6968 25.1134V26.0321ZM29.6968 23.7317C29.6968 23.8601 29.6078 23.9633 29.4972 23.9633C29.3887 23.9633 29.2998 23.8601 29.2998 23.7317V22.8106C29.2998 22.6847 29.3887 22.5816 29.4972 22.5816C29.6078 22.5816 29.6968 22.6847 29.6968 22.8106V23.7317ZM29.6968 21.4314C29.6968 21.5572 29.6078 21.6604 29.4972 21.6604C29.3887 21.6604 29.2998 21.5572 29.2998 21.4314V20.5102C29.2998 20.3819 29.3887 20.2812 29.4972 20.2812C29.6078 20.2812 29.6968 20.3819 29.6968 20.5102V21.4314ZM29.6968 19.1285C29.6968 19.2569 29.6078 19.3601 29.4972 19.3601C29.3887 19.3601 29.2998 19.2569 29.2998 19.1285V18.2099C29.2998 18.0815 29.3887 17.9784 29.4972 17.9784C29.6078 17.9784 29.6968 18.0815 29.6968 18.2099V19.1285ZM29.6968 16.8282C29.6968 16.9565 29.6078 17.0572 29.4972 17.0572C29.3887 17.0572 29.2998 16.9565 29.2998 16.8282V15.907C29.2998 15.7812 29.3887 15.678 29.4972 15.678C29.6078 15.678 29.6968 15.7812 29.6968 15.907V16.8282ZM29.6968 14.5279C29.6968 14.6537 29.6078 14.7569 29.4972 14.7569C29.3887 14.7569 29.2998 14.6537 29.2998 14.5279V13.6067C29.2998 13.4784 29.3887 13.3752 29.4972 13.3752C29.6078 13.3752 29.6968 13.4784 29.6968 13.6067V14.5279ZM28.6771 12.9473C28.7855 12.9473 28.8745 13.0505 28.8745 13.1789C28.8745 13.3047 28.7855 13.4079 28.6771 13.4079H27.883C27.7745 13.4079 27.6855 13.3047 27.6855 13.1789C27.6855 13.0505 27.7745 12.9473 27.883 12.9473H28.6771ZM26.694 12.9473C26.8025 12.9473 26.8915 13.0505 26.8915 13.1789C26.8915 13.3047 26.8025 13.4079 26.694 13.4079H25.8999C25.7893 13.4079 25.7003 13.3047 25.7003 13.1789C25.7003 13.0505 25.7893 12.9473 25.8999 12.9473H26.694ZM24.7088 12.9473C24.8194 12.9473 24.9084 13.0505 24.9084 13.1789C24.9084 13.3047 24.8194 13.4079 24.7088 13.4079H23.9169C23.8062 13.4079 23.7173 13.3047 23.7173 13.1789C23.7173 13.0505 23.8062 12.9473 23.9169 12.9473H24.7088ZM22.7257 12.9473C22.8342 12.9473 22.9232 13.0505 22.9232 13.1789C22.9232 13.3047 22.8342 13.4079 22.7257 13.4079H21.9317C21.8232 13.4079 21.7342 13.3047 21.7342 13.1789C21.7342 13.0505 21.8232 12.9473 21.9317 12.9473H22.7257ZM20.7427 12.9473C20.8512 12.9473 20.9401 13.0505 20.9401 13.1789C20.9401 13.3047 20.8512 13.4079 20.7427 13.4079H19.9486C19.838 13.4079 19.749 13.3047 19.749 13.1789C19.749 13.0505 19.838 12.9473 19.9486 12.9473H20.7427ZM18.7575 12.9473C18.8681 12.9473 18.9571 13.0505 18.9571 13.1789C18.9571 13.3047 18.8681 13.4079 18.7575 13.4079H17.9656C17.8549 13.4079 17.766 13.3047 17.766 13.1789C17.766 13.0505 17.8549 12.9473 17.9656 12.9473H18.7575ZM16.7744 12.9473C16.8829 12.9473 16.9719 13.0505 16.9719 13.1789C16.9719 13.3047 16.8829 13.4079 16.7744 13.4079H15.9803C15.8719 13.4079 15.7829 13.3047 15.7829 13.1789C15.7829 13.0505 15.8719 12.9473 15.9803 12.9473H16.7744ZM14.7914 12.9473C14.8999 12.9473 14.9888 13.0505 14.9888 13.1789C14.9888 13.3047 14.8999 13.4079 14.7914 13.4079H13.9973C13.8866 13.4079 13.7977 13.3047 13.7977 13.1789C13.7977 13.0505 13.8866 12.9473 13.9973 12.9473H14.7914ZM12.8062 12.9473C12.9168 12.9473 13.0058 13.0505 13.0058 13.1789C13.0058 13.3047 12.9168 13.4079 12.8062 13.4079H12.0142C11.9036 13.4079 11.8146 13.3047 11.8146 13.1789C11.8146 13.0505 11.9036 12.9473 12.0142 12.9473H12.8062ZM10.8231 12.9473C10.9316 12.9473 11.0206 13.0505 11.0206 13.1789C11.0206 13.3047 10.9316 13.4079 10.8231 13.4079H10.029C9.92054 13.4079 9.83159 13.3047 9.83159 13.1789C9.83159 13.0505 9.92054 12.9473 10.029 12.9473H10.8231ZM8.84006 12.9473C8.94855 12.9473 9.0375 13.0505 9.0375 13.1789C9.0375 13.3047 8.94855 13.4079 8.84006 13.4079H8.04598C7.93533 13.4079 7.84637 13.3047 7.84637 13.1789C7.84637 13.0505 7.93533 12.9473 8.04598 12.9473H8.84006ZM6.85485 12.9473C6.9655 12.9473 7.05445 13.0505 7.05445 13.1789C7.05445 13.3047 6.9655 13.4079 6.85485 13.4079H6.24952H6.23867H6.22565H6.2148H6.20178H6.19094H6.17792H6.16707H6.15405H6.1432H6.13019H6.11934H6.10632H6.09547H6.08462H6.07161L6.06076 13.4054H6.05859C5.94794 13.4054 5.86115 13.2997 5.86332 13.1713C5.86549 13.0455 5.95662 12.9448 6.0651 12.9473H6.06727H6.07812H6.08896H6.09981H6.11283H6.12368H6.13453H6.14537H6.15622H6.16924H6.18009H6.19094H6.20395H6.2148H6.22565H6.23867H6.24952H6.85485Z",
    fill: "#BF4934"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4299 10.5213H6.17555C5.11026 10.5213 4.24023 9.50959 4.24023 8.27637V10.4383C4.56351 11.1681 5.22308 11.6715 5.98028 11.6715H30.4299V10.5213Z",
    fill: "#EB7F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07331 29.3519C5.96483 29.3519 5.87587 29.2487 5.87587 29.1203C5.87587 28.9945 5.96483 28.8913 6.07331 28.8913H7.18416C7.29264 28.8913 7.3816 28.9945 7.3816 29.1203C7.3816 29.2487 7.29264 29.3519 7.18416 29.3519H6.07331ZM8.37529 29.3519C8.26464 29.3519 8.17569 29.2487 8.17569 29.1203C8.17569 28.9945 8.26464 28.8913 8.37529 28.8913H9.16721C9.27786 28.8913 9.36682 28.9945 9.36682 29.1203C9.36682 29.2487 9.27786 29.3519 9.16721 29.3519H8.37529ZM10.3583 29.3519C10.2477 29.3519 10.1587 29.2487 10.1587 29.1203C10.1587 28.9945 10.2477 28.8913 10.3583 28.8913H11.1524C11.2609 28.8913 11.3499 28.9945 11.3499 29.1203C11.3499 29.2487 11.2609 29.3519 11.1524 29.3519H10.3583ZM12.3414 29.3519C12.2329 29.3519 12.144 29.2487 12.144 29.1203C12.144 28.9945 12.2329 28.8913 12.3414 28.8913H13.1355C13.244 28.8913 13.3329 28.9945 13.3329 29.1203C13.3329 29.2487 13.244 29.3519 13.1355 29.3519H12.3414ZM14.3266 29.3519C14.216 29.3519 14.127 29.2487 14.127 29.1203C14.127 28.9945 14.216 28.8913 14.3266 28.8913H15.1185C15.2292 28.8913 15.3181 28.9945 15.3181 29.1203C15.3181 29.2487 15.2292 29.3519 15.1185 29.3519H14.3266ZM16.3097 29.3519C16.199 29.3519 16.1101 29.2487 16.1101 29.1203C16.1101 28.9945 16.199 28.8913 16.3097 28.8913H17.1038C17.2122 28.8913 17.3012 28.9945 17.3012 29.1203C17.3012 29.2487 17.2122 29.3519 17.1038 29.3519H16.3097ZM18.2927 29.3519C18.1842 29.3519 18.0953 29.2487 18.0953 29.1203C18.0953 28.9945 18.1842 28.8913 18.2927 28.8913H19.0868C19.1953 28.8913 19.2842 28.9945 19.2842 29.1203C19.2842 29.2487 19.1953 29.3519 19.0868 29.3519H18.2927ZM20.2779 29.3519C20.1673 29.3519 20.0783 29.2487 20.0783 29.1203C20.0783 28.9945 20.1673 28.8913 20.2779 28.8913H21.0698C21.1805 28.8913 21.2695 28.9945 21.2695 29.1203C21.2695 29.2487 21.1805 29.3519 21.0698 29.3519H20.2779ZM22.261 29.3519C22.1503 29.3519 22.0614 29.2487 22.0614 29.1203C22.0614 28.9945 22.1503 28.8913 22.261 28.8913H23.0551C23.1636 28.8913 23.2525 28.9945 23.2525 29.1203C23.2525 29.2487 23.1636 29.3519 23.0551 29.3519H22.261ZM24.244 29.3519C24.1355 29.3519 24.0466 29.2487 24.0466 29.1203C24.0466 28.9945 24.1355 28.8913 24.244 28.8913H25.0381C25.1488 28.8913 25.2356 28.9945 25.2356 29.1203C25.2356 29.2487 25.1488 29.3519 25.0381 29.3519H24.244ZM26.2292 29.3519C26.1186 29.3519 26.0296 29.2487 26.0296 29.1203C26.0296 28.9945 26.1186 28.8913 26.2292 28.8913H27.0212C27.1318 28.8913 27.2208 28.9945 27.2208 29.1203C27.2208 29.2487 27.1318 29.3519 27.0212 29.3519H26.2292ZM28.2123 29.3519C28.1016 29.3519 28.0149 29.2487 28.0149 29.1203C28.0149 28.9945 28.1016 28.8913 28.2123 28.8913H29.0064C29.1149 28.8913 29.2038 28.9945 29.2038 29.1203C29.2038 29.2487 29.1149 29.3519 29.0064 29.3519H28.2123ZM29.5423 28.1337C29.5423 28.2596 29.4533 28.3628 29.3449 28.3628C29.2342 28.3628 29.1452 28.2596 29.1452 28.1337V27.2126C29.1452 27.0842 29.2342 26.9836 29.3449 26.9836C29.4533 26.9836 29.5423 27.0842 29.5423 27.2126V28.1337ZM29.5423 25.8309C29.5423 25.9592 29.4533 26.0624 29.3449 26.0624C29.2342 26.0624 29.1452 25.9592 29.1452 25.8309V24.9123C29.1452 24.7839 29.2342 24.6807 29.3449 24.6807C29.4533 24.6807 29.5423 24.7839 29.5423 24.9123V25.8309ZM29.5423 23.5305C29.5423 23.6589 29.4533 23.7596 29.3449 23.7596C29.2342 23.7596 29.1452 23.6589 29.1452 23.5305V22.6094C29.1452 22.4836 29.2342 22.3804 29.3449 22.3804C29.4533 22.3804 29.5423 22.4836 29.5423 22.6094V23.5305ZM29.5423 21.2302C29.5423 21.356 29.4533 21.4592 29.3449 21.4592C29.2342 21.4592 29.1452 21.356 29.1452 21.2302V20.3091C29.1452 20.1807 29.2342 20.08 29.3449 20.08C29.4533 20.08 29.5423 20.1807 29.5423 20.3091V21.2302ZM29.5423 18.9274C29.5423 19.0557 29.4533 19.1589 29.3449 19.1589C29.2342 19.1589 29.1452 19.0557 29.1452 18.9274V18.0087C29.1452 17.8804 29.2342 17.7772 29.3449 17.7772C29.4533 17.7772 29.5423 17.8804 29.5423 18.0087V18.9274ZM29.5423 16.627C29.5423 16.7554 29.4533 16.856 29.3449 16.856C29.2342 16.856 29.1452 16.7554 29.1452 16.627V15.7059C29.1452 15.58 29.2342 15.4768 29.3449 15.4768C29.4533 15.4768 29.5423 15.58 29.5423 15.7059V16.627ZM29.5423 14.3267C29.5423 14.4525 29.4533 14.5557 29.3449 14.5557C29.2342 14.5557 29.1452 14.4525 29.1452 14.3267V13.4055C29.1452 13.2772 29.2342 13.1765 29.3449 13.1765C29.4533 13.1765 29.5423 13.2772 29.5423 13.4055V14.3267ZM28.5247 12.7461C28.6332 12.7461 28.7222 12.8493 28.7222 12.9777C28.7222 13.1035 28.6332 13.2067 28.5247 13.2067H27.7306C27.62 13.2067 27.531 13.1035 27.531 12.9777C27.531 12.8493 27.62 12.7461 27.7306 12.7461H28.5247ZM26.5395 12.7461C26.6502 12.7461 26.7391 12.8493 26.7391 12.9777C26.7391 13.1035 26.6502 13.2067 26.5395 13.2067H25.7454C25.6369 13.2067 25.548 13.1035 25.548 12.9777C25.548 12.8493 25.6369 12.7461 25.7454 12.7461H26.5395ZM24.5565 12.7461C24.6649 12.7461 24.7539 12.8493 24.7539 12.9777C24.7539 13.1035 24.6649 13.2067 24.5565 13.2067H23.7624C23.6539 13.2067 23.5649 13.1035 23.5649 12.9777C23.5649 12.8493 23.6539 12.7461 23.7624 12.7461H24.5565ZM22.5734 12.7461C22.6819 12.7461 22.7708 12.8493 22.7708 12.9777C22.7708 13.1035 22.6819 13.2067 22.5734 13.2067H21.7793C21.6687 13.2067 21.5797 13.1035 21.5797 12.9777C21.5797 12.8493 21.6687 12.7461 21.7793 12.7461H22.5734ZM20.5882 12.7461C20.6988 12.7461 20.7878 12.8493 20.7878 12.9777C20.7878 13.1035 20.6988 13.2067 20.5882 13.2067H19.7941C19.6856 13.2067 19.5967 13.1035 19.5967 12.9777C19.5967 12.8493 19.6856 12.7461 19.7941 12.7461H20.5882ZM18.6051 12.7461C18.7136 12.7461 18.8026 12.8493 18.8026 12.9777C18.8026 13.1035 18.7136 13.2067 18.6051 13.2067H17.8111C17.7026 13.2067 17.6136 13.1035 17.6136 12.9777C17.6136 12.8493 17.7026 12.7461 17.8111 12.7461H18.6051ZM16.6221 12.7461C16.7306 12.7461 16.8195 12.8493 16.8195 12.9777C16.8195 13.1035 16.7306 13.2067 16.6221 13.2067H15.828C15.7174 13.2067 15.6284 13.1035 15.6284 12.9777C15.6284 12.8493 15.7174 12.7461 15.828 12.7461H16.6221ZM14.6369 12.7461C14.7475 12.7461 14.8365 12.8493 14.8365 12.9777C14.8365 13.1035 14.7475 13.2067 14.6369 13.2067H13.8428C13.7343 13.2067 13.6453 13.1035 13.6453 12.9777C13.6453 12.8493 13.7343 12.7461 13.8428 12.7461H14.6369ZM12.6538 12.7461C12.7623 12.7461 12.8513 12.8493 12.8513 12.9777C12.8513 13.1035 12.7623 13.2067 12.6538 13.2067H11.8597C11.7513 13.2067 11.6623 13.1035 11.6623 12.9777C11.6623 12.8493 11.7513 12.7461 11.8597 12.7461H12.6538ZM10.6686 12.7461C10.7793 12.7461 10.8682 12.8493 10.8682 12.9777C10.8682 13.1035 10.7793 13.2067 10.6686 13.2067H9.87668C9.76603 13.2067 9.67708 13.1035 9.67708 12.9777C9.67708 12.8493 9.76603 12.7461 9.87668 12.7461H10.6686ZM8.68555 12.7461C8.7962 12.7461 8.88516 12.8493 8.88516 12.9777C8.88516 13.1035 8.7962 13.2067 8.68555 13.2067H7.89146C7.78298 13.2067 7.69403 13.1035 7.69403 12.9777C7.69403 12.8493 7.78298 12.7461 7.89146 12.7461H8.68555ZM6.7025 12.7461C6.81098 12.7461 6.89994 12.8493 6.89994 12.9777C6.89994 13.1035 6.81098 13.2067 6.7025 13.2067H6.09717H6.08416H6.07331H6.06029H6.04944H6.03642H6.02557H6.01256H6.00171H5.98869H5.97784H5.96483H5.95398H5.94313H5.93011H5.91926L5.90624 13.2042H5.90408C5.79559 13.2042 5.70881 13.0985 5.71098 12.9701C5.71098 12.8443 5.8021 12.7436 5.91275 12.7461H5.91492H5.92577H5.93662H5.94747H5.95832H5.96916H5.98218H5.99303H6.00388H6.01473H6.02774H6.03859H6.04944H6.06246H6.07331H6.08416H6.09717H6.7025Z",
    fill: "#FFBA5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4297 18.6178H31.1023V17.8552H30.4297V18.6178Z",
    fill: "#BF4934"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.659 19.0884H30.4302V24.21H24.659C23.9756 24.21 23.418 23.5632 23.418 22.7704V20.528C23.418 19.7352 23.9756 19.0884 24.659 19.0884Z",
    fill: "#BF4934"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.358 18.6178H30.433L31.1034 17.8552V23.2789L30.4308 23.7395H24.358C23.6767 23.7395 23.1191 23.0901 23.1191 22.2999V20.0574C23.1191 19.2646 23.6767 18.6178 24.358 18.6178Z",
    fill: "#E8644C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.358 18.6178H30.433L31.1034 17.8552V18.2957L30.433 19.0557H24.358C23.6767 19.0557 23.1191 19.7051 23.1191 20.4953V20.0574C23.1191 19.2646 23.6767 18.6178 24.358 18.6178Z",
    fill: "#EB7F61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4297 18.6178L31.1023 17.8552V23.2789L30.4297 23.7395V18.6178Z",
    fill: "#D1543E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4051 19.7148C26.1232 19.7148 26.7047 20.3893 26.7047 21.2224C26.7047 22.0554 26.1232 22.7299 25.4051 22.7299C24.6891 22.7299 24.1055 22.0554 24.1055 21.2224C24.1055 20.3893 24.6891 19.7148 25.4051 19.7148Z",
    fill: "#D1543E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3682 19.8281C26.0126 19.8281 26.5333 20.4322 26.5333 21.1796C26.5333 21.9271 26.0126 22.5311 25.3682 22.5311C24.7238 22.5311 24.2031 21.9271 24.2031 21.1796C24.2031 20.4322 24.7238 19.8281 25.3682 19.8281Z",
    fill: "#B9BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3682 19.8281C25.4941 19.8281 25.6134 19.8508 25.7262 19.8936C26.0647 20.1125 26.2925 20.5303 26.2925 21.011C26.2925 21.7182 25.7978 22.2921 25.1881 22.2921C24.8562 22.2921 24.5589 22.1209 24.3572 21.8516C24.2595 21.6528 24.2031 21.4238 24.2031 21.1796C24.2031 20.4322 24.7238 19.8281 25.3682 19.8281Z",
    fill: "#E1E3E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61124 28.3904V11.0196C4.46154 10.851 4.3357 10.6547 4.24023 10.4382V28.3904C4.24023 29.8275 5.25346 31.0028 6.49232 31.0028H6.86333C5.62229 31.0028 4.61124 29.8275 4.61124 28.3904Z",
    fill: "#EB7F61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12891 30.4668H30.4291V31.0029H6.49144C5.9794 31.0029 5.50642 30.8015 5.12891 30.4668Z",
    fill: "#BF4934"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 16.252H13.4443V18.1798H5.25391V16.252Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 16.4785H6.02847V17.8703H5.25391V16.4785Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 16.252H13.4443V16.4785H5.25391V16.252Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4121 16.6194C12.436 16.8232 12.4468 17.0347 12.4468 17.2511C12.4468 17.4625 12.436 17.6689 12.4121 17.8702H13.4449V16.6194H12.4121Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 16.6195H13.4443V16.4785H5.25391V16.6195Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 16.4785H6.02847V16.6195H5.25391V16.4785Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 17.8701H13.4443V18.1797H5.25391V17.8701Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.1797H14.3176V20.105H6.125V18.1797Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.4038H6.90173V19.7981H6.125V18.4038Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.1797H14.3176V18.4037H6.125V18.1797Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2832 18.5447C13.3071 18.7485 13.3201 18.9599 13.3201 19.1764C13.3201 19.3878 13.3092 19.5942 13.2854 19.798H14.3181V18.5447H13.2832Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.5447H14.3176V18.4038H6.125V18.5447Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.4038H6.90173V18.5447H6.125V18.4038Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 19.7981H14.3176V20.1051H6.125V19.7981Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 20.1052H13.4443V22.0306H5.25391V20.1052Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 20.3291H6.02847V21.7234H5.25391V20.3291Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 20.1052H13.4443V20.3292H5.25391V20.1052Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4121 20.47C12.436 20.6738 12.4468 20.8852 12.4468 21.1017C12.4468 21.3131 12.436 21.522 12.4121 21.7233H13.4449V20.47H12.4121Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 20.47H13.4443V20.3291H5.25391V20.47Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 20.3291H6.02847V20.47H5.25391V20.3291Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 21.7234H13.4443V22.0304H5.25391V21.7234Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 22.0305H13.4443V23.9559H5.25391V22.0305Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 22.2546H6.02847V23.6489H5.25391V22.2546Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 22.0305H13.4443V22.2545H5.25391V22.0305Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4121 22.3955C12.436 22.6019 12.4468 22.8108 12.4468 23.0272C12.4468 23.2386 12.436 23.4475 12.4121 23.6489H13.4449V22.3955H12.4121Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 22.3956H13.4443V22.2546H5.25391V22.3956Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 22.2546H6.02847V22.3956H5.25391V22.2546Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 23.6487H13.4443V23.9557H5.25391V23.6487Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 23.9558H12.798V25.8811H4.60547V23.9558Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 24.1797H5.38003V25.574H4.60547V24.1797Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 23.9558H12.798V24.1798H4.60547V23.9558Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7637 24.3208C11.7875 24.5272 11.8006 24.7386 11.8006 24.9525C11.8006 25.1639 11.7875 25.3728 11.7658 25.5742H12.7986V24.3208H11.7637Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 24.3206H12.798V24.1797H4.60547V24.3206Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 24.1797H5.38003V24.3206H4.60547V24.1797Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 25.574H12.798V25.881H4.60547V25.574Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 25.8811H13.4443V27.8064H5.25391V25.8811Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 26.1052H6.02847V27.4995H5.25391V26.1052Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 25.8811H13.4443V26.1051H5.25391V25.8811Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4121 26.2461C12.436 26.4525 12.4468 26.6639 12.4468 26.8778C12.4468 27.0917 12.436 27.2981 12.4121 27.4995H13.4449V26.2461H12.4121Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 26.2462H13.4443V26.1052H5.25391V26.2462Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 26.1052H6.02847V26.2462H5.25391V26.1052Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 27.4995H13.4443V27.8066H5.25391V27.4995Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 27.8064H12.7236V29.7317H4.5332V27.8064Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 28.033H5.30776V29.4247H4.5332V28.033Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 27.8064H12.7236V28.0329H4.5332V27.8064Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6914 28.1738C11.7131 28.3777 11.7261 28.5891 11.7261 28.8055C11.7261 29.017 11.7153 29.2233 11.6914 29.4247H12.7242V28.1738H11.6914Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 28.1739H12.7236V28.033H4.5332V28.1739Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 28.033H5.30776V28.1739H4.5332V28.033Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5332 29.4248H12.7236V29.7319H4.5332V29.4248Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 29.7319H13.4443V31.6598H5.25391V29.7319Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 29.9585H6.02847V31.3528H5.25391V29.9585Z",
    fill: "#FFD861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 29.7319H13.4443V29.9584H5.25391V29.7319Z",
    fill: "#FFD147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4121 30.0994C12.436 30.3032 12.4468 30.5146 12.4468 30.7311C12.4468 30.9425 12.436 31.1489 12.4121 31.3527H13.4449V30.0994H12.4121Z",
    fill: "#FAAA20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 30.0994H13.4443V29.9585H5.25391V30.0994Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 29.9585H6.02847V30.0994H5.25391V29.9585Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25391 31.3525H13.4443V31.6596H5.25391V31.3525Z",
    fill: "#FFAF26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98536 23.9558C6.98773 24.215 7.84257 24.9197 8.39149 25.8811H4.60547V23.9558H5.98536Z",
    fill: "#F2B51B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20056 25.574C8.26782 25.6721 8.33074 25.7753 8.39149 25.881H4.60547V25.574H8.20056Z",
    fill: "#F2B51B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39121 25.8811C8.71448 26.4474 8.92928 27.1017 9.00521 27.8064H5.25391V25.8811H8.39121Z",
    fill: "#F7BC28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39121 25.8811C8.43243 25.9541 8.47365 26.0296 8.51054 26.1051H5.25391V25.8811H8.39121Z",
    fill: "#F7BC28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51015 26.1052C8.53402 26.153 8.55571 26.2009 8.57958 26.2462H5.25352V26.1052H8.51015ZM8.96361 27.4995C8.97879 27.6002 8.99398 27.7034 9.00483 27.8066H5.25352V27.4995H8.96361ZM9.00483 27.8066C9.01351 27.8821 9.02002 27.9576 9.02435 28.0331H4.5332V27.8066H9.00483Z",
    fill: "#F2B51B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00483 27.8064C9.02435 27.9926 9.0352 28.1814 9.0352 28.3752C9.0352 28.8483 8.97228 29.3039 8.85729 29.7317H4.5332V27.8064H9.00483Z",
    fill: "#F7BC28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02436 28.033C9.0287 28.0783 9.03087 28.1261 9.03087 28.1739H4.5332V28.033H9.02436ZM8.92889 29.4247C8.90937 29.5304 8.88333 29.6311 8.85729 29.7318H4.5332V29.4247H8.92889ZM8.85729 29.7318C8.8356 29.8098 8.8139 29.8828 8.79004 29.9583H5.25352V29.7318H8.85729Z",
    fill: "#F2B51B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85768 29.7319C8.6559 30.4769 8.29357 31.1363 7.81842 31.6598H5.25391V29.7319H8.85768Z",
    fill: "#F7BC28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79042 29.9585C8.77523 30.0063 8.76004 30.0516 8.74269 30.0994H5.25391V29.9585H8.79042ZM8.07227 31.3528C7.99199 31.4585 7.90737 31.5617 7.81842 31.6598H5.25391V31.3528H8.07227Z",
    fill: "#F2B51B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40318 22.9214C6.55763 22.9214 8.30419 24.9499 8.30419 27.4491C8.30419 29.9482 6.55763 31.9768 4.40318 31.9768C2.24656 31.9768 0.5 29.9482 0.5 27.4491C0.5 24.9499 2.24656 22.9214 4.40318 22.9214Z",
    fill: "#FFC42E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40274 23.9937C6.04733 23.9937 7.37949 25.5415 7.37949 27.4492C7.37949 29.3569 6.04733 30.9047 4.40274 30.9047C2.75816 30.9047 1.42383 29.3569 1.42383 27.4492C1.42383 25.5415 2.75816 23.9937 4.40274 23.9937Z",
    fill: "#FCE379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40274 23.9937C5.04062 23.9937 5.63076 24.2277 6.11459 24.6228C5.67415 24.3259 5.16212 24.1522 4.6132 24.1522C2.96861 24.1522 1.63645 25.7 1.63645 27.6077C1.63645 28.7755 2.13547 29.8074 2.90135 30.4341C2.01831 29.8326 1.42383 28.7227 1.42383 27.4492C1.42383 25.5415 2.75816 23.9937 4.40274 23.9937Z",
    fill: "#F7CF56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43945 26.3241C3.43945 26.022 3.49586 25.7754 3.61302 25.5892C3.72801 25.4029 3.90158 25.2821 4.13373 25.2267V24.8945H4.6718V25.2267C4.90612 25.2796 5.08403 25.3979 5.20119 25.5841C5.31836 25.7704 5.37694 26.017 5.37694 26.3241V26.465H4.75425V26.2788C4.75425 26.1177 4.72604 26.0019 4.66746 25.9365C4.61105 25.871 4.52861 25.8383 4.42663 25.8383C4.32249 25.8383 4.24221 25.871 4.18363 25.9365C4.12505 26.0019 4.09685 26.1177 4.09685 26.2788C4.09685 26.4348 4.12939 26.5657 4.19231 26.6764C4.2574 26.7897 4.33551 26.8929 4.43097 26.9885C4.52861 27.0841 4.63058 27.1798 4.74123 27.2704C4.84971 27.3635 4.95169 27.4667 5.04932 27.5825C5.14478 27.6982 5.22289 27.8316 5.28798 27.9826C5.3509 28.1336 5.38344 28.3174 5.38344 28.5313C5.38344 28.8383 5.32269 29.0875 5.20336 29.2762C5.08403 29.4625 4.90612 29.5833 4.6718 29.6336V29.9608H4.13373V29.6336C3.8929 29.5833 3.71499 29.4625 3.59783 29.2762C3.4785 29.0875 3.41992 28.8383 3.41992 28.5313V28.2242H4.04261V28.5766C4.04261 28.7377 4.07298 28.8509 4.1359 28.9163C4.19665 28.9793 4.28127 29.012 4.38324 29.012C4.48738 29.012 4.56983 28.9793 4.63275 28.9163C4.6935 28.8509 4.72604 28.7377 4.72604 28.5766C4.72604 28.4231 4.6935 28.2897 4.62841 28.1789C4.56549 28.0682 4.48521 27.9625 4.38975 27.8668C4.29429 27.7712 4.19231 27.6781 4.08166 27.585C3.97318 27.4944 3.86904 27.3887 3.77357 27.2729C3.67811 27.1596 3.59783 27.0237 3.53491 26.8727C3.46982 26.7217 3.43945 26.538 3.43945 26.3241Z",
    fill: "#FAAA20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5387:32808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.0078125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedCommisionsIcn);
export default __webpack_public_path__ + "static/media/Received Commisions Icn.b05ee6f9.svg";
export { ForwardRef as ReactComponent };